import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import {
  army_category,
  army_category_full,
  army_category_last_update,
} from '@Api';
import { ArmyCategory, ArmyCategoryVersioning } from '@Models';
import { IMapper } from '../IMapper';
import { VersionGameMapper } from './VersionGameMapper';
import { UnitCategoryMapper } from './UnitCategoryMapper';

@injectable()
export class ArmyCategoryMapper
  implements IMapper<number, army_category_full, army_category, ArmyCategory>
{
  @inject(TYPES.Mapper.VersionGameMapper)
  private _versionGameMapper!: VersionGameMapper;
  @inject(TYPES.Mapper.UnitCategoryMapper)
  private _unitMapper!: UnitCategoryMapper;

  map(item: army_category_full): ArmyCategory {
    return {
      id: item.id,
      name: item.name ?? '',
      updatedAt: item.updated_at,
      game: this._versionGameMapper.map(item.game),
      units: [],
    } satisfies ArmyCategory as ArmyCategory;
  }

  public mapFull(item: army_category): ArmyCategory {
    return {
      id: item.id,
      name: item.name ?? '',
      updatedAt: item.updated_at,
      game: this._versionGameMapper.map(item.game),
      units: item.units.map((u) => this._unitMapper.map(u)),
    } satisfies ArmyCategory as ArmyCategory;
  }

  public mapVersioning(
    data: army_category_last_update,
  ): ArmyCategoryVersioning {
    return {
      id: data.id,
      name: data.name ?? '',
      updatedAt: data.updated_at,
    } satisfies ArmyCategoryVersioning as ArmyCategoryVersioning;
  }
}
